var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"sp sp1",class:_vm.icon}),_c('span',{staticClass:"sp sp2"},[_vm._v(_vm._s(_vm.buttonText))]),_c('span',{staticClass:"sp sp3"},[_vm._v(_vm._s(_vm.tipText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }